import Vue from 'vue'
import routerPageHook from '@assets/js/routerPageHook.js'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import qualityService from '../../components/ui-components/quality-service/component'
import BannerBtn from '@components/ui-components/banner-btn/component.js'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      error: false,

      visibleText: false,
      visibleBtn: false,
      heightFull: null,
      heightHide: null,
      height: null,
    }
  },
  components: {
    'quality-service-cmp': qualityService,
    'page-form-cmp': PageForm,
    'banner-btn-cmp': BannerBtn,
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {
    ...mapActions('modal', ['modalType_certificatesOpen']),
    errorData(data) {
      this.error = data.error
    },
    openDesc() {
      this.visibleText = !this.visibleText
      if (this.visibleText) {
        this.height = this.heightFull
      } else {
        this.height = this.heightHide
      }
    },
  },
  mounted() {
    setTimeout(() => {
      let leftHeight = this.$refs.containerLeft.clientHeight
      let rightHeight = this.$refs.containerRight.clientHeight
      if (leftHeight && rightHeight && leftHeight > rightHeight) {
        this.visibleBtn = true
        setTimeout(() => {
          this.heightFull = this.$refs.containerLeft.clientHeight
          this.heightHide = rightHeight
          this.height = Math.max(this.heightHide, 300)
        }, 10)
      } else {
        this.visibleText = true
      }
    }, 100)
  },
  ...routerPageHook,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/quality-policy/index.js